import { Text, TextProps } from '@chakra-ui/react';

interface ReceiptDataProps extends TextProps {
  children?: string | string[] | number;
}

export default function ReceiptData({ children, ...props }: ReceiptDataProps) {
  return (
    <Text
      fontSize=".875rem"
      fontWeight={500}
      lineHeight="128.571%"
      textAlign={{ base: 'left', lg: 'right' }}
      overflowWrap="anywhere"
      {...props}
    >
      {children}
    </Text>
  );
}
